import { render, staticRenderFns } from "./name.vue?vue&type=template&id=cb5f2c12&scoped=true"
import script from "./name.vue?vue&type=script&lang=js"
export * from "./name.vue?vue&type=script&lang=js"
import style0 from "./name.vue?vue&type=style&index=0&id=cb5f2c12&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb5f2c12",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
